// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__RQw6s","item":"Navigation_item__PQCMi","active":"Navigation_active__8X7xS"};